"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const invariant_1 = __importDefault(require("invariant"));
const create_hmac_1 = __importDefault(require("create-hmac"));
const secp256k1_1 = require("./secp256k1");
// the BIP32 class is inspired from https://github.com/bitcoinjs/bip32/blob/master/src/bip32.js
class BIP32 {
    constructor(publicKey, chainCode, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    network, depth = 0, index = 0) {
        (0, invariant_1.default)(publicKey && publicKey.length > 0, "publicKey must not be empty");
        (0, invariant_1.default)(chainCode && chainCode.length > 0, "chainCode must not be empty");
        this.publicKey = publicKey;
        this.chainCode = chainCode;
        this.network = network;
        this.depth = depth;
        this.index = index;
    }
    derive(index) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = Buffer.allocUnsafe(37);
            this.publicKey.copy(data, 0);
            data.writeUInt32BE(index, 33);
            const I = (0, create_hmac_1.default)("sha512", this.chainCode).update(data).digest();
            const IL = I.slice(0, 32);
            const IR = I.slice(32);
            const Ki = Buffer.from(yield (0, secp256k1_1.getSecp256k1Instance)().publicKeyTweakAdd(this.publicKey, IL));
            return new BIP32(Ki, IR, this.network, this.depth + 1, index);
        });
    }
}
exports.default = BIP32;
//# sourceMappingURL=bip32.js.map